import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { Milliseconds, toTimestamp } from '@mi-front/core';
import { useCallback } from 'react';
import { DisplayableChunk } from '../../../../../../types';

/**
 * Hook for chunk playback that always restarts from chunk beginning when called.
 * Works in both parent mode and independent mode.
 *
 * @param chunk - The chunk whose bounds will be used for playback
 * @returns Function to start/restart playback from chunk beginning
 */
export function useChunkPlayback(chunk: DisplayableChunk) {
  const play = usePlaybackPlay();

  const startTs = toTimestamp(chunk.from) as Milliseconds;
  const stopTs = toTimestamp(chunk.to) as Milliseconds;

  const playChunk = useCallback(() => {
    // Always restart from chunk beginning
    play({ startTs, stopTs });
  }, [play, startTs, stopTs]);

  return { playChunk };
}
